<cm-topbar title="Bidder"></cm-topbar>

<div class="main-content">

  <div class="container">
    <div class="row">
      <div class="col">
        <mat-horizontal-stepper [linear]="'true'" #stepper>

          <mat-step label="Info" completed="true">
            <div class="mat-step-content-wrapper">
              <div class="mat-step-content cm-card">
                <div class="row">
                  <div class="col-12 col-md">
                    <h4 class="mat-step-content-title">
                      Premium Bidder is here!
                    </h4>
                    <div class="mat-step-content-body">
                      <p>Order your Consumable bidder now, get the benefits:</p>
                      <ul>
                        <li>Serve Premium content instead of just ads</li>
                        <li>Higher impact ad units</li>
                        <li>Expose your inventory to unique demand</li>
                        <li>Get higher CPM's and yield than market average</li>
                      </ul>
                      <p>
                        If you are already using Prebid, please find the installation instructions in the below link. If
                        you are not using Prebid, we can help you with setting this up on your Website.
                      </p>
                      <p class="mb-0">
                        <a href="https://publishers.consumable.com/docs/Consumable-Prebid-Setup.pdf" target="_blank"
                           mat-button color="primary" class="iconed">
                          Instruction document
                        </a></p>
                    </div>
                  </div>
                  <div class="col-12 col-md-auto text-center mat-step-content-icon d-none d-lg-block">
                    <img src="assets/images/icons/icon_bidder_step_1.svg" alt=""/>
                    <small class="d-block mt-4">Revenue share 80/20</small>
                  </div>
                </div>
              </div>
              <div class="mat-step-actions d-flex justify-content-center">
                <button mat-raised-button color="primary" class="large" matStepperNext>START</button>
              </div>
            </div>
          </mat-step>

          <!--SITES-->
          <mat-step label="Sites" [completed]="request?._domains.length > 0">
            <div class="mat-step-content-wrapper">
              <div class="mat-step-content cm-card">
                <div class="row">
                  <div class="col-12 col-md">
                    <h4 class="mat-step-content-title">
                      Choose sites
                      <!--<small>You are able to setup our bidder only on sites with a valid ads.txt records.</small>-->
                      <!--<small>Sites with a valid ads.txt records are eligible for selection.</small>-->
                      <small>All of your sites will be listed but only those with valid ads.txt records are available for selection.</small>
                    </h4>
                    <div class="mat-step-content-body">
                      <div class="d-flex">
                        <mat-form-field class="w-100 mr-lg-5">
                          <mat-select placeholder="Select site(s)"
                                      (selectionChange)="onDomainSelected()"
                                      multiple
                                      [(ngModel)]="request._domains">
                            <mat-checkbox (change)="onClickSelectAllDomains($event)" class="select-all-domains">Select all</mat-checkbox>
                            <mat-optgroup *ngFor="let group of siteGroups" [label]="group.name"
                                          [disabled]="group.disabled">
                              <mat-option *ngFor="let site of group.sites" [value]="site">
                                {{site.url}}
                              </mat-option>
                            </mat-optgroup>
                          </mat-select>
                        </mat-form-field>
                        <!--<mat-form-field class="w-100">-->
                          <!--<mat-select placeholder="Select domain"-->
                                      <!--[(ngModel)]="selectedDomain"-->
                                      <!--(selectionChange)="onExistingDomainSelected($event.value)">-->
                            <!--<mat-option *ngFor="let domain of availableDomains" [value]="domain">-->
                              <!--{{ domain.url }}-->
                            <!--</mat-option>-->
                          <!--</mat-select>-->
                        <!--</mat-form-field>-->
                        <!--<button mat-mini-fab color="primary" (click)="addNewDomain()" class="ml-4">-->
                          <!--<i class="fas fa-plus" aria-hidden="true"></i>-->
                        <!--</button>-->
                      </div>

                      <!--<dl class="step-domain-warning-list" *ngIf="domainWidgetValidation"-->
                          <!--[hidden]="domainWidgetValidation.valid">-->
                        <!--<dt>You are already running following size(s) on this domain:</dt>-->
                        <!--<dd *ngFor="let u of domainWidgetValidation.unitsRunningSameSizeWidgets">-->
                          <!--{{u.name}}-->
                        <!--</dd>-->
                      <!--</dl>-->

                      <!--<mat-chip-list class="mat-chip-list-stacked d-block mt-3">-->
                        <!--<mat-basic-chip *ngFor="let domain of request?.newDomains"-->
                                        <!--class="d-flex align-items-center">-->
                          <!--<span class="step-domain-name" title="{{domain}}">-->
                            <!--{{domain}}-->
                          <!--</span>-->
                          <!--<span-->
                            <!--class="d-inline-flex align-items-center mr-2 ml-2 badge badge-pill badge-default">new</span>-->
                          <!--<span (click)="removeNewUrlDomain(domain)" class="remove-chip">-->
                            <!--<i class="fas fa-times" aria-hidden="true"></i>-->
                          <!--</span>-->
                        <!--</mat-basic-chip>-->
                        <!--<mat-basic-chip *ngFor="let domain of request?._domains">-->
                          <!--{{domain.url}}-->
                          <!--<span (click)="removeExistingDomain(domain)" class="remove-chip">-->
                            <!--<i class="fas fa-times" aria-hidden="true"></i>-->
                          <!--</span>-->
                        <!--</mat-basic-chip>-->
                      <!--</mat-chip-list>-->
                    </div>
                  </div>
                  <div class="col-12 col-md-auto text-center mat-step-content-icon d-none d-lg-block">
                    <img src="assets/images/icons/icon_bidder_step_4.svg" alt=""/>
                  </div>
                </div>
              </div>
              <div class="mat-step-actions d-flex justify-content-between">
                <button mat-button color="primary" matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!request?._domains.length">Next</button>
              </div>
            </div>
          </mat-step>

          <!--CONTENT-->
          <mat-step label="Content" completed="true">
            <div class="mat-step-content-wrapper">
              <div class="">
                <h4 class="mat-step-content-title">
                  Choose content type
                </h4>
                <div class="mat-step-content-body">
                  <div class="row mb-3">

                    <div class="col-12 mb-4 col-md-6 mb-md-0 text-center"
                         [class.selected]="chosenContentType==='audio'"
                         (click)="chosenContentType='audio'; onContentTypeChange('audio')">
                      <div class="cm-card cm-card--bidder-select p-4 h-100">
                        <div *ngIf="exampleAudioWidget" class="mb-3 d-none d-md-block">
                          <img [src]="exampleAudioWidget.demoImageUrl">
                        </div>
                        <h5 class="mb-3"><strong>Music</strong></h5>
                        <p>Consumable has partnered with Deezer to offer publishers access to over 30M premium songs
                          that can be curated into playlists appealing to targeted demographics.</p>
                        <span class="bidder-select-icon" [class.visible]="chosenContentType==='audio'">
                          <i class="fas fa-check" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 text-center"
                         [class.selected]="chosenContentType==='ebooks'"
                         (click)="chosenContentType='ebooks'; onContentTypeChange('ebooks')">
                      <div class="cm-card cm-card--bidder-select p-4 h-100">
                        <div *ngIf="exampleEbooksWidget" class="mb-3 d-none d-md-block">
                          <img [src]="exampleEbooksWidget.demoImageUrl">
                        </div>
                        <h5 class="mb-3"><strong>Audio Books</strong></h5>
                        <p>Consumable has partnered with NY Times to offer publishers access to Best Selling Ebooks that
                          can be curated into playlists appealing to targeted demographics.</p>
                        <span class="bidder-select-icon" [class.visible]="chosenContentType==='ebooks'">
                          <i class="fas fa-check" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mat-step-actions d-flex justify-content-between">
                <button mat-button color="primary" matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext>Next</button>
              </div>
            </div>
          </mat-step>

          <!--AD SIZE-->
          <mat-step label="Ad size" [completed]="adSizeStepCompleted ">
            <div class="mat-step-content-wrapper">
              <div class="mat-step-content cm-card">
                <div class="row">
                  <div class="col-12 col-md mr-lg-5">
                    <h4 class="mat-step-content-title">Choose ad size</h4>
                    <div class="mat-step-content-body">
                      <div class="row align-items-start mb-2"
                           *ngFor="let w of availableWidgetTypesForContent">
                        <div class="col">
                          <mat-checkbox [(ngModel)]="w._selected" (change)="onWidgetSelected(w, $event.checked)">
                            {{w.displayName}}
                          </mat-checkbox>
                          <mat-radio-group *ngIf="w._devicePlacements.length>1 && w._selected"
                                           [(ngModel)]="w._selectedDevicePlacement"
                                           class="d-flex flex-column mt-2 ml-1">
                            <mat-radio-button *ngFor="let dp of w._devicePlacements" [value]="dp"
                                              class="">
                              {{DevicePlacementLabels[dp]}}
                            </mat-radio-button>
                          </mat-radio-group>
                        </div>
                        <div class="col pl-0" *ngIf="domainValidationMap[w.id] && domainValidationMap[w.id].length">
                          <cm-popover class="domain-list">
                            <cm-popover-action>
                              <small class="fas fa-exclamation-circle text-danger mr-2" matTooltip="Size already running on selected sites"></small>
                            </cm-popover-action>
                            <cm-popover-content>
                              <div class="popover-list">
                                <span *ngFor="let d of domainValidationMap[w.id]" class="text-truncate">{{d}}</span>
                              </div>
                            </cm-popover-content>
                          </cm-popover>
                        </div>
                        <div class="col-auto d-none d-md-block mr-4 ">
                          <small class="link" (click)="openPreviewModal(w)">preview</small>
                        </div>
                      </div>
                    </div>

                    <!--<dl class="step-domain-warning-list" *ngIf="domainWidgetValidation"-->
                        <!--[hidden]="domainWidgetValidation.valid">-->
                      <!--<dt>You are already running following unit(s) on selected domains:</dt>-->
                      <!--<dd *ngFor="let u of domainWidgetValidation.unitsRunningSameSizeWidgets">-->
                        <!--{{u.name}}-->
                      <!--</dd>-->
                    <!--</dl>-->
                    </div>
                  <div class="col-12 col-md-auto text-center mat-step-content-icon d-none d-lg-block">
                    <img src="assets/images/icons/icon_bidder_step_3.svg" alt=""/>
                  </div>
                </div>
              </div>
              <div class="mat-step-actions d-flex justify-content-between">
                <button mat-button color="primary" matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!adSizeStepCompleted">Next</button>
              </div>
            </div>
          </mat-step>

          <!--PREBID-->
          <mat-step label="Prebid">
            <div class="mat-step-content-wrapper">
              <div class="mat-step-content cm-card">
                <div class="row">
                  <div class="col-12 col-md">
                    <h4 class="mat-step-content-title">
                      Choose prebid version
                    </h4>
                    <div class="mat-step-content-body">
                      <mat-radio-group [(ngModel)]="request.prebidVersion" class="d-flex flex-column">
                        <mat-radio-button value="Latest" class="mb-3 mat-radio-button--multiline">
                          Latest prebid adapter
                          <small>compatible with 1.xx versions</small>
                        </mat-radio-button>
                        <mat-radio-button value="Legacy" class="mb-3 mat-radio-button--multiline">
                          Legacy prebid adapter
                          <small>compatible with 0.xx versions</small>
                        </mat-radio-button>
                      </mat-radio-group>
                      <p class="mb-0">
                        Download "Consumable" adapter
                        <a href="http://prebid.org/download.html" target="_blank" color="primary"
                           class="link iconed">here</a>
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md-auto text-center mat-step-content-icon d-none d-lg-block">
                    <img src="assets/images/icons/icon_bidder_step_5.svg" alt=""/>
                  </div>
                </div>
              </div>
              <div class="mat-step-actions d-flex justify-content-between">
                <button mat-button color="primary" matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext>Next</button>
              </div>
            </div>
          </mat-step>

          <!--DONE-->
          <mat-step label="Summary">
            <div class="mat-step-content-wrapper">
              <div class="mat-step-content cm-card">
                <div class="row">
                  <div class="col-12 col-md">
                    <h4 class="mat-step-content-title">
                      Summary
                    </h4>
                    <div class="mat-step-content-body">
                      <ul class="bidder-summary-list list-unstyled">
                        <li class="mat-list-item">
                          <label>Content:</label>
                          <strong>{{chosenContentType}}</strong>
                        </li>
                        <li class="mat-list-item">
                          <label>Sizes:</label>
                          <strong>{{getSelectedWidgetTypesString()}}</strong>
                        </li>
                        <li class="mat-list-item">
                          <label>Domain/s:</label>
                          <strong class="d-flex flex-column">
                                        <span *ngFor="let domain of request?.newDomains" class="mb-1">
                                          {{domain}}
                                          <span
                                            class="d-inline-flex align-items-center ml-2 badge badge-pill badge-default">new</span>
                                        </span>
                            <span *ngFor="let domain of request?._domains">{{domain.url}}</span>
                          </strong>
                        </li>
                        <li class="mat-list-item">
                          <label>Prebid:</label>
                          <strong>{{request.prebidVersion}}</strong>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-12 col-md-auto text-center mat-step-content-icon d-none d-lg-block">
                    <img src="assets/images/icons/icon_bidder_step_6.svg" alt=""/>
                  </div>
                </div>
              </div>
              <div class="mat-step-actions d-flex align-items-start justify-content-between">
                <button mat-button color="primary" matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" (click)="submit()" class="large">Submit</button>
              </div>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
  </div>

</div>
